import {DOCUMENT} from '@angular/common';
import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn} from '@angular/router';

import {LaunchDarklyService} from 'frontend/services/launch_darkly_service';

/**
 * A higher-order function that returns an Angular `CanActivateFn` to protect
 * routes based on a LaunchDarkly feature flag.
 */
export function featureFlagGuard(flagKey: string): CanActivateFn {
  return ({data}: ActivatedRouteSnapshot): boolean => {
    const launchDarklyService = inject(LaunchDarklyService);
    const canActivate = launchDarklyService.evaluate(flagKey, false);
    const document = inject(DOCUMENT);

    if (!canActivate) {
      document.location.href = data.appPath;
    }

    return canActivate;
  };
}
